<template>
  <image-box-tool-with-options
    v-if="show"
    ref="menu"
    v-bind="{
      title,
      icon,
      ...$attrs
    }"
  >
    <div
      v-for="(font, index) in collageFonts"
      :key="index"
      class="image-box__option"
      :class="{'image-box__option--selected': isSelected(font) }"
      @click.prevent.stop="setFont(font.font_family, font.display_name)"
    >
      <span
        :key="index"
        :style="{'font-family': font.font_family}"
        class="text-font-box-tool__font-demo"
      >
        {{ font.display_name }}
      </span>
    </div>
  </image-box-tool-with-options>
</template>
<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'TextFontBoxTool',
  extends: ImageBoxTool,
  inheritAttrs: false,
  data() {
    return {
      icon: 'font',
      title: 'Fonts',
      showLocal: true,
      hotkey: 'ctrl+y',
    };
  },
  computed: {
    fonts() {
      return this.$store.state.fonts.items;
    },
    collageFonts() {
      // return this.fonts.filter((font) => font.in_collages);
      return this.fonts;
    },
    show() {
      return this.showLocal;
    },
  },

  mounted() {
    this.activate();
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    isSelected(font) {
      if (this.canvas && this.canvas.getActiveObject()) {
        return font.font_family === this.canvas.getActiveObject().fontFamily;
      }

      return false;
    },
    activate() {
      if (this.canvas && this.canvas.getActiveObject()) {
        this.showLocal = (this.canvas.getActiveObject().get('type') === 'i-text' || this.canvas.getActiveObject().get('type') === 'textbox');
      } else {
        this.showLocal = false;
      }
      this.$emit('changeSubmenuValue', null);
    },
    setFont(font, displayName) {
      this.font = font;
      this.fontDisplayName = displayName;

      const active = this.canvas.getActiveObject();
      if (active) {
        active.set({
          fontFamily: font,
          displayName,
          styles: [],
        });
      }
      // Closing menu
      this.$refs.menu.close();
      // We need to render the canvas to apply these changes
      this.canvas.renderAll();
      this.$emit('changeSubmenuValue', null);
      this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
    },
  },
};
</script>
<style lang="scss" scoped>
.text-font-box-tool__font-demo{
  font-size: 0.875rem;
  white-space: nowrap;
}
</style>
